/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthGoalDto
 */
export interface HealthGoalDto {
    /**
     * One of the top 3 things the user would like to change about their health
     * @type {string}
     * @memberof HealthGoalDto
     */
    text: string;
    /**
     * Unique identifier for the health goal
     * @type {string}
     * @memberof HealthGoalDto
     */
    id?: string;
}

/**
 * Check if a given object implements the HealthGoalDto interface.
 */
export function instanceOfHealthGoalDto(value: object): value is HealthGoalDto {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function HealthGoalDtoFromJSON(json: any): HealthGoalDto {
    return HealthGoalDtoFromJSONTyped(json, false);
}

export function HealthGoalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthGoalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function HealthGoalDtoToJSON(json: any): HealthGoalDto {
    return HealthGoalDtoToJSONTyped(json, false);
}

export function HealthGoalDtoToJSONTyped(value?: HealthGoalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'id': value['id'],
    };
}

